<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Middle Rate Report</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content ref="contentDiv">
      <v-container grid-list-lg>
        <v-layout fluid wrap>
          <v-flex xs4>
            <v-select
              :items="currencies"
              item-text="currencyCode"
              item-value="currencyCode"
              label="Currency"
              v-model="cboCurrency"
            ></v-select>
          </v-flex>
          <v-flex xs4>
            <v-select
              :items="years"
              label="Year"
              v-model="cboYear"
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-btn
              outline
              block
              :disabled="cboCurrency.length === 0 || cboYear.length === 0"
              @click="getReport(cboCurrency, cboYear)"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs2>
            <v-btn
              outline
              block
              :disabled="cboCurrency.length === 0 || cboYear.length === 0"
              @click="getReport(cboCurrency, cboYear, 'csv')"
            >
              CSV
            </v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="report"
              hide-actions
              class="elevation-1"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center subheading font-weight-bold">
                    Currency
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Year
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Month
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Average Rate (from USD)
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :class="(props.index % 2 === 0 ? 'row1' : 'row2')">
                  <td class="text-xs-center">{{ props.item.currencyCode | allCaps }}</td>
                  <td class="text-xs-center">{{ props.item.year }}</td>
                  <td class="text-xs-center">{{ props.item.monthName }}</td>
                  <td class="text-xs-center">{{ formatPrice(props.item.averageExchangeRateToBase, 10) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import downloadjs from 'downloadjs'
import axios from 'axios'
// import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      user: null,
      drawer: false,
      loading: false,
      cboCurrency: '',
      currencies: [],
      cboYear: '',
      years: [],
      report: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.generateYears()
    this.getCurrencies()
    this.disableBottomDetector()
  },

  methods: {
    generateYears: function () {
      var results = []
      var currentYear = new Date().getFullYear()
      for (var c = 2020; c <= currentYear; c++) {
        results.push(c)
      }
      this.years = results
      this.cboYear = currentYear
    },
    getCurrencies: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getReport: function (currencyCode, year, format = 'json') {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true

        axios.get(process.env.VUE_APP_API_ROOT + '/v1/report/middle-rates/' + currencyCode + '/' + year + '?format=' + format)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (format === 'json') {
              if (resp.data.status === 'success') {
                _this.report = resp.data.data
              } else {
                console.log('unable to load report: ' + resp.data.message)
              }
            } else {
              downloadjs(resp.data, 'middle-rates-report.' + format.toLowerCase(), resp.headers['content-type'])
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>
